<template>
  <component :is="componentName" :test="test" :responseId="responseId" :vacancyToken="vacancyToken" />
</template>

<script>
  import { mapGetters } from 'vuex'
  import SingleTestResult from '@/routes_new/inner/candidate/test/default/SingleTestResult'
  const SchlumSingleTestResult = () =>
    import(/* webpackChunkName: "sibur-test" */ "@/process/schlumberger-career/components/candidate/test/SingleTestResult")

  export default {
    name: 'candidate-tests',

    components: {
      default: SingleTestResult,
      schlumCareer: SchlumSingleTestResult
    },

    props: {
      responseId: {
        type: String,
        required: true
      },
      vacancyToken: {
        type: String,
        default: ''
      },
      test: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('process', ['getProcessName']),

      componentName() {
        if (this.getProcessName === 'schlum-career') {
          return this.getProcessName
          // return 'default'
        } else {
          return 'default'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
